import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteIssueVisibility } from '../../../api';
import { requestGetIssuesArchivedAgain } from '../../archived/actions';
import { requestGetIssuesSnoozedAgain } from '../../snoozed/actions';

export const deleteIssuesByIdVisibilitySlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ requestGetIssuesArchivedAgain, requestGetIssuesSnoozedAgain ]
	},
	name: 'issuesByIdVisibility',
	receive: false,
	request: true,
	requestHandler: deleteIssueVisibility
});
